import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Toaster.html?raw';
import topic from 'dojo/topic';
import Toastmessage from './Toastmessage';
import "./ToasterTypes";
import "./Toastmessage";
import domConstruct from 'dojo/dom-construct';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import methodHooks from 'more/mdsMethodHooks';

class Toaster extends methodHooks(compose(_WidgetBase, _TemplatedMixin)) {
    templateString: any = template;

    private toastContainer: HTMLElement;

    private activeToasts: Array<MdsLax<InstanceType<typeof Toastmessage>>> = [];

    /**
     * Einen neuen Toast erzeugen
     * @param messageOrElement Die sichtbare Beschriftung (kurzer Text)
     * @param icon Optional: Icon aus  toasterIcons oder fontawesome-Klassen
     * @param toastOptions Optionspaket, bestehend aus timeout (Länge der Sichtbarkeit), ID (um Toasts ersetzen oder löschen zu können), Callbackfunktion, Sichtbarkeit des Schließbuttons
     */
    addToast(messageOrElement: string | HTMLElement, icon?: toasterIcons | string, toastOptions?: toastOptions) {
        //var timeout: number | "permanent" = 5000;
        //var toastID: string = null;
        //let bCreateNewToast: boolean = true;

        //console.log("addToast", message, icon, toastOptions);

        let actualToastOptions: toastOptions  = {
            timeout: 5000,
            closeButton: false,
            buttons: [],
            onClick: toastOptions?.onClick,
            ID: null
        };
       
        if (typeof (toastOptions) != "undefined") {
            if (typeof (toastOptions.timeout) != "undefined") {
                actualToastOptions.timeout = toastOptions.timeout;
                actualToastOptions.closeButton = toastOptions.closeButton === true;

                if (actualToastOptions.timeout == "permanent") {
                }

                else if (actualToastOptions.timeout <= 0) {
                    actualToastOptions.closeButton = true;
                }
            }

            if (typeof (toastOptions.ID) != "undefined") {
                actualToastOptions.ID = toastOptions.ID;
            }

            if (typeof (toastOptions.buttons) != "undefined" && toastOptions.buttons.length) {
                actualToastOptions.buttons = toastOptions.buttons;
            }

        }
        let toast: MdsLax<InstanceType<typeof Toastmessage>> = null;

        if (actualToastOptions.ID != null && typeof (actualToastOptions.ID) != "undefined") {

            for (let activeToast of this.activeToasts) {
                if (activeToast.uniqueID == actualToastOptions.ID) {
                    
                    toast = activeToast;
                    break;
                }
            }
        }

        if (!toast) {

            toast = new Toastmessage();

            domConstruct.place(toast.domNode, this.toastContainer);

            let height = toast.domNode.getBoundingClientRect().height;            
            if (!height) height = 75;
            toast.domNode.style.setProperty("--elementHeight", height + "px");

            setTimeout(lang.hitch(this, domClass.add, toast.domNode, "toastMessageGrowAnimation"), 1);
            //setTimeout(lang.hitch(this, domClass.remove, toast.domNode, "toastMessageGrowAnimation"), 10);
        }

        toast.setMessage(messageOrElement);
        toast.setIcon(icon as toasterIcons);
        toast.setOptions(actualToastOptions);


        if (typeof (actualToastOptions.timeout) == "number" && actualToastOptions.timeout > 0) {
            if (toast.timeout != null) {
                clearTimeout(<number>toast.timeout);
            }
            toast.timeout = setTimeout(lang.hitch(this, this.removeToast, toast), actualToastOptions.timeout);
        }
        this.activeToasts.push(toast);
    }

    removeToastById (ID: string) {

        //console.log("removeToastById", ID);

        if (typeof (ID) == "undefined" || ID == null) {
            return;
        }

        for (var i = 0; i < this.activeToasts.length; i++) {
            var toast: MdsLax<InstanceType<typeof Toastmessage>> = this.activeToasts[i];
            if (toast.uniqueID == ID) {
                this.removeToast(toast);

                break;
            }
        }
    }

    removeToast(toast: MdsLax<InstanceType<typeof Toastmessage>> | string) {

        if (typeof (toast) == "string") {
            this.removeToastById(toast);
            return;
        }

        if ((toast as any)._destroyed || toast.isDestroying == true) {
            return;
        }

        toast.isDestroying = true; // damit der nächste Klick nicht zu einem Fehler führt

        var undeletedToasts: MdsLax<InstanceType<typeof Toastmessage>>[] = [];
        for (var i = 0; i < this.activeToasts.length; i++) {
            if (this.activeToasts[i] != toast) {
                undeletedToasts.push(this.activeToasts[i]);
            }
        }

        this.activeToasts = undeletedToasts;

        let height = toast.domNode.getBoundingClientRect().height;
        //toast.domNode.style.setProperty("--travelDistance", height + "px");
        //domClass.add(toast.domNode, "w3-animate-exittop");

        toast.domNode.style.setProperty("--elementHeight", height + "px");
        domClass.add(toast.domNode, "toastMessageShrinkAnimation");

        //// dem Toast eine Transition geben
        //domStyle.set(toast.domNode, "transition", "0.5s");
        //domStyle.set(toast.domNode, "opacity", 0);

        setTimeout(lang.hitch(toast, "destroy"), 3400);
    }

    //// Weiß nicht was das ist, wofür und woher
    ////
    ////_searchInput_Execute (startIndex) {
    ////    this._loadResultRows(startIndex);

    ////    clearTimeout(this._searchTimeoutFct);
    ////    this._searchTimeoutFct = null;
    ////}

    removeAllToasts(): void {
        for (var i = 0; i < this.activeToasts.length; i++) {

            domStyle.set(this.activeToasts[i].domNode, "transition", "0.5s");
            domStyle.set(this.activeToasts[i].domNode, "opacity", 0);

            setTimeout(lang.hitch(this.activeToasts[i], "destroy"), 510);
        }

        this.activeToasts = [];
    }

    private _subscriptions: Array<dojo.Handle> = [];
    addSubscription(topicName, callback) {
        this._subscriptions.push(topic.subscribe(topicName, callback));
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse     
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

        this._subscriptions = [];

        // default placement:
        domConstruct.place(this.domNode, document.body);
        // pointer-events: none; position: fixed; width: 100%; bottom: 0px; z-index: 50;
        domStyle.set(this.domNode, "poinerEvents", "none");
        domStyle.set(this.domNode, "position", "fixed");
        domStyle.set(this.domNode, "width", "100%");
        domStyle.set(this.domNode, "bottom", "0px");
        domStyle.set(this.domNode, "zIndex", "50");

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._subscriptions.push(topic.subscribe("toastMessage/removeToast", lang.hitch(this, function (toast) { this.removeToast(toast); })));
    }

    destroy() {
        try {
            for (let subscription of this._subscriptions) {
                subscription.remove();
            }
        } catch (ex) {
            console.warn(this.id + ": subscriptions could not be removed while destroying", ex);
        }
        super.destroy.apply(this, arguments as any);
    }
}

export default mdsWidget(Toaster);
